module.exports = __webpack_public_path__ + "static/media/ios-nutrition.7fb8777d.svg";